import {
  NodeViewContent,
  NodeViewWrapper,
  type NodeViewProps,
} from "@tiptap/react";
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import { useUIStore } from "../store/ui";

const LANGUAGES: { value: string; label: string }[] = [
  { value: "plaintext", label: "Plain text" },
  { value: "bash", label: "Bash" },
  { value: "css", label: "CSS" },
  { value: "html", label: "HTML" },
  { value: "javascript", label: "JavaScript" },
  { value: "json", label: "JSON" },
  { value: "python", label: "Python" },
  { value: "sql", label: "SQL" },
  { value: "swift", label: "Swift" },
  { value: "typescript", label: "TypeScript" },
];

export function CodeBlockView({ node, updateAttributes }: NodeViewProps) {
  const [hovered, setHovered] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);
  const language: string = node.attrs.language ?? "plaintext";

  return (
    <NodeViewWrapper
      className="code-block-wrapper"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Language picker — always shows a subtle label, full dropdown on hover */}
      <div
        style={{
          opacity: hovered || selectOpen ? 1 : 0,
          pointerEvents: hovered ? "auto" : "none",
          transition: "opacity 0.15s",
          position: "absolute",
          top: 2,
          right: 2,
          zIndex: 10,
        }}
      >
        <Select
          value={language}
          onValueChange={(val) => {
            const lang = val === "plaintext" ? null : val;
            updateAttributes({ language: lang });
            useUIStore.getState().setLastCodeLanguage(lang);
          }}
          open={selectOpen}
          onOpenChange={setSelectOpen}
        >
          <SelectTrigger className="bg-transparent px-2 py-0.5 text-[10px] gap-1 [&_svg]:size-2 rounded-[10px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent align="end">
            {LANGUAGES.map((lang) => (
              <SelectItem key={lang.value} value={lang.value}>
                {lang.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <pre>
        <NodeViewContent
          as={"code" as unknown as "div"}
          className={
            language && language !== "plaintext" ? `language-${language}` : ""
          }
        />
      </pre>
    </NodeViewWrapper>
  );
}
